import PropTypes from "prop-types"
import React from "react"
import ResetPassword from "src/main/Account/Settings/ResetPassword"
import WorkOsUserSecurityPanel from "src/main/Account/Settings/WorkOsUserSecurityPanel"

import HeadingPageTitle from "src/components/Heading/HeadingPageTitle"

const LoginAndSecurity = ({
  minimumPasswordLength,
  workosUserSecurityWidgetEnabled,
}) => (
  <div className="grid grid-cols-12">
    <div className="col-span-12 mb-8 mt-1">
      <HeadingPageTitle>Login and Security</HeadingPageTitle>
    </div>
    <div className="col-span-12 lg:col-span-6">
      {workosUserSecurityWidgetEnabled ? (
        <WorkOsUserSecurityPanel />
      ) : (
        <ResetPassword minimumPasswordLength={minimumPasswordLength} />
      )}
    </div>
  </div>
)

LoginAndSecurity.propTypes = {
  minimumPasswordLength: PropTypes.number.isRequired,
  workosUserSecurityWidgetEnabled: PropTypes.bool.isRequired,
}

export default LoginAndSecurity
